module.exports = __webpack_public_path__ + "img/qr_telegram.ba12d3d2.svg";